import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import "./components/css/admin.css";
import "./components/css/responsive.css";
import "./components/css/mdb.min.css";
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);
const suppressedWarnings = [
  "ResizeObserver loop limit exceeded",
  "ResizeObserver",
];
const originalError = console.error;

console.error = (...args) => {
  if (
    typeof args[0] === "string" &&
    suppressedWarnings.some((sw) => args[0].includes(sw))
  ) {
    return;
  }
  originalError.apply(console, args);
};
window.onerror = function (message, source, lineno, colno, error) {
  if (message.includes("ResizeObserver")) {
    console.warn("Suppressed ResizeObserver error:", message);
    return true;
  }
  return false;
};
const originalConsoleWarn = console.warn;

console.warn = (message, ...args) => {
  if (message.includes("[React Flow]: Couldn't create edge")) {
    return;
  }
  originalConsoleWarn(message, ...args);
};
console.warn = originalConsoleWarn;

root.render(<App />);
